import { RootStoreType } from './RootStore';
import { flow, getRoot, Instance, SnapshotIn, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { BankHolidayDate } from './models/BankHolidayDate';
import { getEnvironment } from './utils/utils';

export const BankHolidayDateSearchCriteria = types.model({
  year: types.maybeNull(types.number),
});

export const BankHolidayDateStore = types
  .compose(
    getBaseStore<Instance<typeof BankHolidayDate>, Instance<typeof BankHolidayDate>>(
      BankHolidayDate,
      'bankHolidayDateId',
      'bankHolidayDate',
    ),
    types.model('BankHolidayDateStore', {}),
  )
  .actions((self) => {
    const env = getEnvironment(self);
    const root: RootStoreType = getRoot(self);
    const apiFetcher = env.api;

    const search = flow(function*(criteria: Instance<typeof BankHolidayDateSearchCriteria>) {
      const result = yield apiFetcher.get('bankholidaydate/' + criteria.year, {
        params: criteria,
      });
      // @ts-ignore
      self.putInStore(result);
      // @ts-ignore
      const resultIds = result.map((r) => r.bankHolidayDateId);
      return self.dataList.filter((d) => resultIds.indexOf(d.bankHolidayDateId) >= 0);
    });

    return {
      search,
      afterAttach: flow(function*() {
        yield self.loadList();
      }),
    };
  });

export type BankHolidayDateStoreType = Instance<typeof BankHolidayDateStore>;
